import { jsx as _jsx } from "react/jsx-runtime";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { Root } from '../styles';
const ListInput = (props) => {
    const { id, value, values, caption, tooltip = '', size = 'small', disabled = false, onChange } = props;
    const handleChange = (e) => {
        if (onChange) {
            const val = e?.target?.value;
            onChange(val);
        }
    };
    return (_jsx(Root, { size: size, children: _jsx(TextField, { id: id, select: true, value: value, label: caption, helperText: tooltip, disabled: disabled, onChange: handleChange, variant: "outlined", children: values.map((item, idx) => (_jsx(MenuItem, { value: item.value, children: item.text }, idx.toString()))) }) }));
};
export default ListInput;
//# sourceMappingURL=ListInput.js.map